import { render, staticRenderFns } from "./HistoryStories.vue?vue&type=template&id=2ad2c678&scoped=true"
import script from "./HistoryStories.vue?vue&type=script&lang=js"
export * from "./HistoryStories.vue?vue&type=script&lang=js"
import style0 from "./HistoryStories.vue?vue&type=style&index=0&id=2ad2c678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad2c678",
  null
  
)

export default component.exports